const translations = {
  // Nav
  "nav.home": "خانه",
  "nav.mission": "مأموریت",
  "nav.projects": "پروژه‌ها",
  "nav.stories": "داستان‌ها",
  "nav.volunteer": "داوطلب",
  "nav.donate": "کمک",
  "nav.contact": "تماس",
  "nav.donateNow": "همین حالا کمک کنید",

  // Language bar
  "lang.managed": "از طریق داشبورد مدیریت CMS اداره می‌شود",

  // Hero
  "hero.badge": "پل‌سازی · امیدآفرینی",
  "hero.title": "توانمندسازی جوامع افغانستان از طریق آموزش و فرصت‌ها",
  "hero.subtitle": "بنیاد کانادا افغانستان کانادایی‌های مهربان را با جوامع نیازمند افغانستان پیوند می‌دهد — تأمین مالی آموزش، بهداشت و توسعه پایدار از سال ۲۰۱۶.",
  "hero.cta.donate": "از مأموریت ما حمایت کنید",
  "hero.cta.learn": "داستان ما را بخوانید",
  "hero.scroll": "پایین",

  // Mission Preview
  "mission.tag": "مأموریت ما",
  "mission.title": "پلی میان دو ملت، ساخته شده بر اساس شفقت",
  "mission.body1": "بنیاد کانادا افغانستان (CAF) یک مؤسسه خیریه ثبت شده کانادایی است که به بهبود زندگی مردم افغانستان از طریق برنامه‌های هدفمند در زمینه آموزش، بهداشت و توسعه جامعه اختصاص دارد.",
  "mission.body2": "ما باور داریم که هر کودک افغان سزاوار دسترسی به آموزش است، هر خانواده سزاوار آب پاک است، و هر جامعه سزاوار فرصت شکوفایی است — صرف نظر از جنگ یا شرایط.",
  "mission.cta": "مأموریت کامل ما را بخوانید",
  "mission.pillar.education": "آموزش",
  "mission.pillar.education.desc": "تأمین مالی مکاتب، بورسیه‌ها و آموزش‌های حرفه‌ای برای جوانان و زنان افغان.",
  "mission.pillar.healthcare": "بهداشت",
  "mission.pillar.healthcare.desc": "استقرار کلینیک‌های سیار و حمایت از متخصصان پزشکی در مناطق محروم.",
  "mission.pillar.community": "جامعه",
  "mission.pillar.community.desc": "ایجاد زیرساخت‌ها، دسترسی به آب پاک و حمایت از اسکان مجدد پناهندگان در کانادا.",
  "mission.pillar.sustainability": "پایداری",
  "mission.pillar.sustainability.desc": "توانمندسازی رهبران و سازمان‌های محلی برای ایجاد تغییر پایدار و خودکفا.",

  // Projects Preview
  "projects.tag": "ابتکارات فعال",
  "projects.title": "پروژه‌های کنونی ما",
  "projects.subtitle": "هر پروژه با دقت طراحی شده است تا تأثیری پایدار در جوامع افغانستان ایجاد کند. این چیزی است که ما در حال حاضر روی آن کار می‌کنیم.",
  "projects.viewAll": "مشاهده همه پروژه‌ها",
  "projects.learnMore": "بیشتر بدانید",
  "projects.raised": "جمع‌آوری شده",
  "projects.completed": "تکمیل شده",

  // Impact
  "impact.tag": "تأثیر ما",
  "impact.title": "تغییر واقعی، ارقام واقعی",
  "impact.subtitle": "هر دالر اهدا شده به تأثیری قابل اندازه‌گیری در میدان تبدیل می‌شود. این چیزی است که با هم به دست آورده‌ایم.",
  "impact.students": "دانش‌آموزان حمایت شده",
  "impact.students.desc": "دختران و پسرانی که از طریق برنامه‌های بورسیه و مکتب ما آموزش با کیفیت دریافت می‌کنند.",
  "impact.water": "افراد دارای آب پاک",
  "impact.water.desc": "خانواده‌ها در مناطق روستایی افغانستان اکنون به آب آشامیدنی سالم و پاک دسترسی دارند.",
  "impact.medical": "مشاوره‌های پزشکی",
  "impact.medical.desc": "مراقبت‌های بهداشتی رایگان از طریق برنامه کلینیک سیار ما از سال ۲۰۱۸ ارائه شده است.",
  "impact.families": "خانواده‌های اسکان داده شده",
  "impact.families.desc": "خانواده‌های پناهنده افغان که در زندگی جدید خود در کانادا حمایت شده‌اند.",

  // Volunteer Preview
  "volunteer.tag": "مشارکت کنید",
  "volunteer.title": "به جامعه تغییرآفرینان ما بپیوندید",
  "volunteer.body1": "چه پزشک باشید، چه مترجم، چه جمع‌آوری‌کننده کمک مالی یا علاقه‌مند به رسانه‌های اجتماعی — جایی برای شما در CAF وجود دارد. مهارت‌های شما می‌تواند زندگی‌ها را تغییر دهد.",
  "volunteer.body2": "ما فرصت‌های داوطلبی برای کانادایی‌ها و اعضای دیاسپورای افغان داریم، هم از راه دور و هم حضوری.",
  "volunteer.cta": "داوطلب شوید",
  "volunteer.otherWays": "یا راه‌های دیگر کمک را کشف کنید",
  "volunteer.apply": "درخواست",
  "volunteer.location": "موقعیت",

  // Donate Preview
  "donate.tag": "تفاوت ایجاد کنید",
  "donate.title": "کمک شما، آینده آنها",
  "donate.subtitle": "۱۰۰٪ کمک شما مستقیماً به برنامه‌های میدانی می‌رود. ما یک مؤسسه خیریه ثبت شده کانادایی هستیم — تمام کمک‌ها معاف از مالیات است.",
  "donate.tier.supporter": "حامی",
  "donate.tier.champion": "قهرمان",
  "donate.tier.patron": "پشتیبان",
  "donate.mostPopular": "محبوب‌ترین",
  "donate.highImpact": "تأثیر بالا",
  "donate.donate": "کمک",
  "donate.trust.charity": "مؤسسه خیریه ثبت شده کانادایی",
  "donate.trust.transparent": "۱۰۰٪ شفاف",
  "donate.trust.receipts": "رسیدهای مالیاتی صادر می‌شود",
  "donate.trust.secure": "پردازش امن",

  // Footer
  "footer.tagline": "ایجاد پل‌هایی میان کانادا و افغانستان از طریق آموزش، بهداشت و توسعه جامعه.",
  "footer.charity": "مؤسسه خیریه ثبت شده CRA #123456789",
  "footer.est": "تأسیس ۲۰۱۶",
  "footer.quickLinks": "لینک‌های سریع",
  "footer.getInvolved": "مشارکت کنید",
  "footer.stayConnected": "در ارتباط بمانید",
  "footer.newsletter.desc": "به‌روزرسانی‌های ماهانه درباره تأثیر ما و نحوه کمک شما دریافت کنید.",
  "footer.newsletter.placeholder": "آدرس ایمیل شما",
  "footer.newsletter.success": "از اشتراک شما متشکریم!",
  "footer.newsletter.privacy": "ما به حریم خصوصی شما احترام می‌گذاریم. هر زمان لغو اشتراک کنید.",
  "footer.support": "پشتیبانی به زبان‌های:",
  "footer.privacy": "سیاست حفظ حریم خصوصی",
  "footer.terms": "شرایط استفاده",
  "footer.accessibility": "دسترسی‌پذیری",
  "footer.admin": "مدیر",
  "footer.copyright": "بنیاد کانادا افغانستان. تمامی حقوق محفوظ است.",

  // Contact
  "contact.tag": "تماس بگیرید",
  "contact.title": "خوشحال می‌شویم از شما بشنویم",
  "contact.subtitle": "درباره برنامه‌های ما سؤال دارید، می‌خواهید با ما همکاری کنید یا به پشتیبانی نیاز دارید؟ تماس بگیرید — ما به انگلیسی، پشتو، دری، فرانسوی و آلمانی پاسخ می‌دهیم.",
  "contact.form.name": "نام کامل",
  "contact.form.email": "آدرس ایمیل",
  "contact.form.subject": "موضوع",
  "contact.form.message": "پیام شما",
  "contact.form.submit": "ارسال پیام",
  "contact.form.sending": "در حال ارسال...",
  "contact.form.success": "پیام ارسال شد! ما ظرف ۴۸ ساعت با شما تماس خواهیم گرفت.",
  "contact.info.address": "آدرس",
  "contact.info.email": "ایمیل",
  "contact.info.phone": "تلفن",
  "contact.info.hours": "ساعات اداری",

  // ========== MISSION PAGE ==========
  "missionPage.tag": "مأموریت ما",
  "missionPage.title": "مأموریتی ریشه‌دار در امید، پیش‌رانده شده با عمل",
  "missionPage.subtitle": "بنیاد کانادا افغانستان وجود دارد تا شکاف میان کانادایی‌های مهربان و جوامع نیازمند افغانستان را پر کند — ایجاد تغییر پایدار از طریق آموزش، بهداشت و توسعه جامعه.",
  "missionPage.who.tag": "ما کیستیم",
  "missionPage.who.title": "ایجاد پل‌هایی میان دو ملت",
  "missionPage.who.body1": "بنیاد CAF در سال ۲۰۱۶ توسط رهبران جامعه افغان-کانادایی در اتاوا تأسیس شد و یک مؤسسه خیریه ثبت شده کانادایی (CRA #123456789) است که به بهبود زندگی مردم افغانستان از طریق برنامه‌های هدفمند، شفاف و تأثیرگذار اختصاص دارد.",
  "missionPage.who.body2": "ما باور داریم که جغرافیا و جنگ هرگز نباید تعیین‌کننده دسترسی یک کودک به آموزش، دسترسی یک خانواده به آب پاک، یا توانایی یک جامعه برای شکوفایی باشد. کار ما بر اساس این اصل هدایت می‌شود که تغییر پایدار از درون جوامع می‌آید — ما توانمند می‌سازیم، نه جایگزین.",
  "missionPage.who.body3": "با شبکه داوطلبی متشکل از ۳۴۰+ فرد متعهد در سراسر کانادا و افغانستان، و همکاری با سازمان‌های غیردولتی محلی افغانستان، ما اطمینان می‌دهیم که هر دالر به کسانی که بیشترین نیاز را دارند می‌رسد.",
  "missionPage.who.ctaProjects": "پروژه‌های ما را ببینید",
  "missionPage.who.ctaSupport": "از ما حمایت کنید",
  "missionPage.who.yearsBadge": "سال تأثیر",
  "missionPage.values.tag": "چه چیزی ما را هدایت می‌کند",
  "missionPage.values.title": "ارزش‌های اصلی ما",
  "missionPage.values.compassion": "شفقت",
  "missionPage.values.compassionDesc": "ما با همدلی و مراقبت نسبت به هر فردی که به او خدمت می‌کنیم عمل می‌کنیم، صرف نظر از پیشینه یا شرایط.",
  "missionPage.values.integrity": "صداقت",
  "missionPage.values.integrityDesc": "ما با شفافیت مالی کامل و پاسخگویی به اهداکنندگان و جوامعی که به آنها خدمت می‌کنیم عمل می‌کنیم.",
  "missionPage.values.collaboration": "همکاری",
  "missionPage.values.collaborationDesc": "ما با سازمان‌های محلی افغانستان، نهادهای کانادایی و سازمان‌های غیردولتی جهانی برای به حداکثر رساندن تأثیر همکاری می‌کنیم.",
  "missionPage.values.sustainability": "پایداری",
  "missionPage.values.sustainabilityDesc": "ما برنامه‌هایی طراحی می‌کنیم که جوامع را برای خودکفایی و تاب‌آوری در طول زمان توانمند می‌سازد.",
  "missionPage.values.equity": "برابری",
  "missionPage.values.equityDesc": "ما آسیب‌پذیرترین افراد — زنان، کودکان و خانواده‌های آواره — را در تمام برنامه‌های خود در اولویت قرار می‌دهیم.",
  "missionPage.values.innovation": "نوآوری",
  "missionPage.values.innovationDesc": "ما به طور مداوم به دنبال راه‌حل‌های خلاقانه و مبتنی بر شواهد برای چالش‌های پیچیده بشردوستانه هستیم.",
  "missionPage.timeline.tag": "سفر ما",
  "missionPage.timeline.title": "۸ سال تأثیر",
  "missionPage.timeline.2016": "CAF در اتاوا توسط رهبران جامعه افغان-کانادایی تأسیس شد",
  "missionPage.timeline.2017": "اولین برنامه بورسیه تحصیلی دختران در کابل راه‌اندازی شد",
  "missionPage.timeline.2018": "برنامه کلینیک سیار بهداشتی در ولایت ننگرهار مستقر شد",
  "missionPage.timeline.2019": "ابتکار آب پاک به ۵۰۰۰ خانواده در هلمند رسید",
  "missionPage.timeline.2020": "امدادرسانی اضطراری کووید-۱۹ — توزیع تجهیزات حفاظتی و غذا به ۳۰۰۰ خانواده",
  "missionPage.timeline.2021": "برنامه اسکان مجدد پناهندگان در تورنتو و اتاوا راه‌اندازی شد",
  "missionPage.timeline.2022": "مراکز آموزش حرفه‌ای در هرات و مزار شریف افتتاح شد",
  "missionPage.timeline.2023": "گسترش به ۱۵ پروژه فعال در ۸ ولایت افغانستان",
  "missionPage.timeline.2024": "حمایت از ۲۵۰۰+ دانش‌آموز؛ ۱۸۰۰۰+ نفر دارای دسترسی به آب پاک",
  "missionPage.cta.title": "بخشی از مأموریت باشید",
  "missionPage.cta.subtitle": "چه کمک مالی کنید، چه داوطلب شوید یا صرفاً خبر را منتشر کنید — شما بخشی از تغییر هستید.",
  "missionPage.cta.donate": "همین حالا کمک کنید",
  "missionPage.cta.volunteer": "با ما داوطلب شوید",

  // ========== PROJECTS PAGE ==========
  "projectsPage.tag": "کاری که می‌کنیم",
  "projectsPage.title": "پروژه‌های ما",
  "projectsPage.subtitle": "از کلاس‌های درس در کابل تا چاه‌های آب در هلمند — هر پروژه گامی به سوی افغانستان بهتر است.",
  "projectsPage.filters.all": "همه",
  "projectsPage.filters.education": "آموزش",
  "projectsPage.filters.healthcare": "بهداشت",
  "projectsPage.filters.infrastructure": "زیرساخت",
  "projectsPage.filters.community": "جامعه",
  "projectsPage.filters.humanitarian": "بشردوستانه",
  "projectsPage.status.all": "همه",
  "projectsPage.status.active": "فعال",
  "projectsPage.status.completed": "تکمیل شده",
  "projectsPage.empty": "هیچ پروژه‌ای برای این فیلتر یافت نشد.",
  "projectsPage.details": "جزئیات",
  "projectsPage.raised": "جمع‌آوری شده",
  "projectsPage.badge.completed": "تکمیل شده",

  // ========== PROJECT DETAIL PAGE ==========
  "projectDetail.home": "خانه",
  "projectDetail.projects": "پروژه‌ها",
  "projectDetail.notFound": "پروژه یافت نشد",
  "projectDetail.notFound.back": "بازگشت به پروژه‌ها",
  "projectDetail.funding.title": "پیشرفت تأمین مالی",
  "projectDetail.funding.raised": "جمع‌آوری شده از",
  "projectDetail.funding.goal": "هدف",
  "projectDetail.funding.funded": "تأمین شده",
  "projectDetail.funding.cta": "به این پروژه کمک کنید",
  "projectDetail.details.title": "جزئیات پروژه",
  "projectDetail.details.category": "دسته‌بندی",
  "projectDetail.details.location": "موقعیت",
  "projectDetail.details.beneficiaries": "ذینفعان",
  "projectDetail.details.status": "وضعیت",
  "projectDetail.details.statusActive": "فعال",
  "projectDetail.details.statusCompleted": "تکمیل شده",
  "projectDetail.body1": "این ابتکار بخشی از تعهد گسترده‌تر CAF برای ایجاد توسعه پایدار و جامعه‌محور در افغانستان است. همکاران محلی ما در میدان اطمینان می‌دهند که منابع به طور عادلانه توزیع شده و برنامه‌ها از نظر فرهنگی مناسب و مؤثر باشند.",
  "projectDetail.body2": "تمام وجوه جمع‌آوری شده مستقیماً به اجرای برنامه‌ها اختصاص می‌یابد. CAF شفافیت مالی کامل را حفظ کرده و گزارش‌های تأثیر منظم به اهداکنندگان ارائه می‌دهد. رسیدهای مالیاتی برای تمام کمک‌های بالای ۲۰ دالر کانادا صادر می‌شود.",
  "projectDetail.back": "بازگشت به همه پروژه‌ها",
  "projectDetail.beneficiariesSuffix": "ذینفع",

  // ========== VOLUNTEER PAGE ==========
  "volunteerPage.tag": "مشارکت کنید",
  "volunteerPage.title": "به جامعه تغییرآفرینان ما بپیوندید",
  "volunteerPage.subtitle": "مهارت‌ها، زمان و اشتیاق شما می‌تواند زندگی‌ها را متحول کند. چه در کانادا باشید چه در خارج، نقشی معنادار برای شما در CAF وجود دارد.",
  "volunteerPage.positions.tag": "موقعیت‌های باز",
  "volunteerPage.positions.title": "فرصت‌های داوطلبی کنونی",
  "volunteerPage.stories.tag": "داستان‌های داوطلبان",
  "volunteerPage.stories.title": "از داوطلبان ما بشنوید",
  "volunteerPage.apply.title": "درخواست داوطلبی",
  "volunteerPage.apply.submitted": "درخواست ثبت شد!",
  "volunteerPage.apply.submittedDesc": "از علاقه شما متشکریم. تیم ما ظرف ۳-۵ روز کاری با شما تماس خواهد گرفت.",
  "volunteerPage.apply.close": "بستن",
  "volunteerPage.form.name": "نام کامل *",
  "volunteerPage.form.namePlaceholder": "نام کامل شما",
  "volunteerPage.form.email": "آدرس ایمیل *",
  "volunteerPage.form.emailPlaceholder": "ایمیل شما",
  "volunteerPage.form.message": "چرا می‌خواهید داوطلب شوید؟ *",
  "volunteerPage.form.messagePlaceholder": "درباره سابقه و انگیزه خود بگویید...",
  "volunteerPage.form.submit": "ارسال درخواست",
  "volunteerPage.form.submitting": "در حال ارسال...",
  "volunteerPage.spotsAvailable": "موقعیت موجود است",
  "volunteerPage.applyNow": "همین حالا درخواست دهید",

  // ========== DONATE PAGE ==========
  "donatePage.tag": "تفاوت ایجاد کنید",
  "donatePage.title": "کمک به CAF",
  "donatePage.subtitle": "سخاوت شما مستقیماً برنامه‌های آموزش، بهداشت و جامعه را برای خانواده‌های افغان تأمین مالی می‌کند. هر دالر مهم است.",
  "donatePage.yourImpact": "تأثیر شما",
  "donatePage.howToDonate": "نحوه کمک",
  "donatePage.tier.friend.label": "دوست",
  "donatePage.tier.friend.impact": "لوازم مکتب برای ۲ دانش‌آموز فراهم می‌کند",
  "donatePage.tier.supporter.label": "حامی",
  "donatePage.tier.supporter.impact": "لوازم مکتب برای ۵ دانش‌آموز برای یک ترم فراهم می‌کند",
  "donatePage.tier.advocate.label": "مدافع",
  "donatePage.tier.advocate.impact": "هزینه دسترسی به آب پاک برای یک خانواده به مدت ۲ ماه را تأمین می‌کند",
  "donatePage.tier.champion.label": "قهرمان",
  "donatePage.tier.champion.impact": "هزینه یک ماه دسترسی به آب پاک برای یک خانواده ۶ نفره را تأمین می‌کند",
  "donatePage.tier.benefactor.label": "نیکوکار",
  "donatePage.tier.benefactor.impact": "مراقبت پزشکی ۱۰ بیمار را در کلینیک سیار ما پوشش می‌دهد",
  "donatePage.tier.patron.label": "پشتیبان",
  "donatePage.tier.patron.impact": "هزینه یک سال کامل تحصیلات متوسطه یک دختر را تأمین می‌کند",
  "donatePage.custom.label": "مبلغ دلخواه (دالر کانادا)",
  "donatePage.custom.placeholder": "مبلغ را وارد کنید",
  "donatePage.custom.note": "برای کمک‌های سفارشی، لطفاً مستقیماً با ما تماس بگیرید تا پرداخت را ترتیب دهیم.",
  "donatePage.custom.contact": "تماس با ما",
  "donatePage.bank.title": "انتقال بانکی",
  "donatePage.bank.desc": "مستقیماً به حساب بانکی کانادایی ما انتقال دهید:",
  "donatePage.bank.name": "بنیاد کانادا افغانستان",
  "donatePage.bank.bank": "بانک",
  "donatePage.bank.bankName": "بانک سلطنتی کانادا (RBC)",
  "donatePage.bank.accountName": "نام حساب",
  "donatePage.bank.accountNum": "شماره حساب",
  "donatePage.bank.transit": "شماره ترانزیت",
  "donatePage.bank.institution": "شماره مؤسسه",
  "donatePage.bank.warning": "مهم: لطفاً نام کامل و ایمیل خود را در یادداشت‌های انتقال درج کنید تا بتوانیم رسید مالیاتی شما را صادر کنیم.",
  "donatePage.cheque.title": "چک",
  "donatePage.cheque.desc": "چکی قابل پرداخت به آدرس زیر پست کنید:",
  "donatePage.cheque.warning": "لطفاً آدرس ایمیل خود را پشت چک بنویسید تا رسید مالیاتی خود را دریافت کنید.",
  "donatePage.inperson.title": "حضوری",
  "donatePage.inperson.desc": "در ساعات اداری به دفتر ما مراجعه کنید:",
  "donatePage.inperson.note": "ما وجه نقد، چک و کارت اعتباری/دبیت را به صورت حضوری می‌پذیریم.",
  "donatePage.tax.title": "رسیدهای مالیاتی",
  "donatePage.tax.desc": "CAF یک مؤسسه خیریه ثبت شده کانادایی است (CRA #123456789). تمام کمک‌های بالای ۲۰ دالر کانادا واجد شرایط دریافت رسید مالیاتی هستند که ظرف ۳۰ روز پس از کمک شما صادر می‌شود.",
  "donatePage.trust.charity": "مؤسسه خیریه ثبت شده",
  "donatePage.trust.transparent": "۱۰۰٪ شفاف",
  "donatePage.trust.secure": "امن و مطمئن",
  "donatePage.trust.programs": "۱۰۰٪ به برنامه‌ها",
  "donatePage.bottom.title": "سؤالی درباره کمک دارید؟",
  "donatePage.bottom.subtitle": "تیم ما خوشحال می‌شود به شما کمک کند تا تأثیرگذارترین کمک ممکن را انجام دهید.",
  "donatePage.bottom.contact": "تماس با تیم ما",

  // ========== CONTACT PAGE ==========
  "contactPage.tag": "تماس بگیرید",
  "contactPage.title": "تماس و پشتیبانی",
  "contactPage.subtitle": "سؤالی دارید، می‌خواهید با ما همکاری کنید یا به پشتیبانی نیاز دارید؟ ما اینجاییم تا کمک کنیم — به انگلیسی، پشتو و دری.",
  "contactPage.form.title": "برای ما پیام بفرستید",
  "contactPage.form.submitted": "پیام ارسال شد!",
  "contactPage.form.submittedDesc": "از تماس شما متشکریم. تیم ما ظرف ۲-۳ روز کاری پاسخ خواهد داد.",
  "contactPage.form.another": "ارسال پیام دیگر",
  "contactPage.form.name": "نام کامل *",
  "contactPage.form.namePlaceholder": "نام کامل شما",
  "contactPage.form.email": "آدرس ایمیل *",
  "contactPage.form.emailPlaceholder": "ایمیل شما",
  "contactPage.form.phone": "شماره تلفن",
  "contactPage.form.phonePlaceholder": "+1 (613) 555-0000",
  "contactPage.form.subject": "موضوع *",
  "contactPage.form.subjectPlaceholder": "یک موضوع انتخاب کنید",
  "contactPage.form.subjectOptions.general": "استعلام عمومی",
  "contactPage.form.subjectOptions.donation": "سؤال درباره کمک",
  "contactPage.form.subjectOptions.volunteer": "درخواست داوطلبی",
  "contactPage.form.subjectOptions.partnership": "پیشنهاد همکاری",
  "contactPage.form.subjectOptions.media": "رسانه و مطبوعات",
  "contactPage.form.subjectOptions.tech": "پشتیبانی فنی",
  "contactPage.form.subjectOptions.other": "سایر",
  "contactPage.form.message": "پیام *",
  "contactPage.form.messagePlaceholder": "چگونه می‌توانیم به شما کمک کنیم؟",
  "contactPage.form.submit": "ارسال پیام",
  "contactPage.form.sending": "در حال ارسال...",
  "contactPage.form.error": "مشکلی پیش آمد. لطفاً دوباره تلاش کنید یا مستقیماً به ما ایمیل بزنید.",
  "contactPage.form.charLimit": "پیام باید ۵۰۰ کاراکتر یا کمتر باشد.",
  "contactPage.form.privacy": "ما به حریم خصوصی شما احترام می‌گذاریم. اطلاعات شما هرگز با اشخاص ثالث به اشتراک گذاشته نخواهد شد.",
  "contactPage.office.title": "دفتر ما",
  "contactPage.office.address": "آدرس",
  "contactPage.office.addressValue": "۱۲۳ خیابان رایدو، سوئیت ۴۰۰\nاتاوا، انتاریو K1N 5Y1، کانادا",
  "contactPage.office.hours": "ساعات اداری",
  "contactPage.office.hoursValue": "دوشنبه تا جمعه: ۹:۰۰ صبح – ۵:۰۰ بعد از ظهر EST",
  "contactPage.office.phone": "تلفن",
  "contactPage.office.email": "ایمیل",
  "contactPage.map.directions": "دریافت مسیر",
  "contactPage.lang.title": "پشتیبانی چندزبانه",
  "contactPage.lang.desc": "ما پشتیبانی به زبان‌های انگلیسی، پشتو و دری ارائه می‌دهیم. لطفاً زبان مورد نظر خود را در پیام خود ذکر کنید.",

  // ========== STORIES PAGE ==========
  "storiesPage.tag": "داستان‌های ما",
  "storiesPage.title": "داستان‌های تأثیر و امید",
  "storiesPage.subtitle": "روایت‌های دست اول از میدان را بخوانید، با افراد پشت مأموریت ما آشنا شوید و از آخرین اخبار CAF مطلع بمانید.",
  "storiesPage.filters.all": "همه",
  "storiesPage.filters.fieldStories": "داستان‌های میدانی",
  "storiesPage.filters.impactReports": "گزارش‌های تأثیر",
  "storiesPage.filters.volunteerVoices": "صدای داوطلبان",
  "storiesPage.filters.news": "اخبار و به‌روزرسانی‌ها",
  "storiesPage.empty": "هیچ داستانی برای این دسته‌بندی یافت نشد.",
  "storiesPage.readMore": "بیشتر بخوانید",
  "storiesPage.backToStories": "بازگشت به همه داستان‌ها",
  "storiesPage.by": "نویسنده",
  "storiesPage.published": "منتشر شده",

  // Stories Preview (Home)
  "storiesPreview.tag": "از میدان",
  "storiesPreview.title": "داستان‌های تأثیر و امید",
  "storiesPreview.subtitle": "داستان‌های واقعی از جوامعی که به آنها خدمت می‌کنیم — روایت شده توسط افرادی که هر روز تغییر را زندگی می‌کنند.",
  "storiesPreview.viewAll": "خواندن همه داستان‌ها",

  // Photo Slider (Home)
  "photoSlider.tag": "در میدان",
  "photoSlider.title": "کار ما در تصاویر",
  "photoSlider.subtitle": "تأثیر حمایت خود را ببینید — لحظات واقعی از پروژه‌های ما در سراسر افغانستان و کانادا.",
};

export default translations;